import React from 'react';
import ReactDOM from 'react-dom';
import Toast from './Toast';

const ToastContainer = ({ toast, onClose }) => {
  if (!toast) return null;

  return ReactDOM.createPortal(
    <Toast
      message={toast.message}
      type={toast.type}
      duration={toast.duration || 10000}
      onClose={onClose}
    />,
    document.body
  );
};

export default ToastContainer;
